// src/components/Service.js
import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Shirdi to Grishneshwar Cab",
    desc: "Book a comfortable Shirdi to Grishneshwar Cab with Rising Cab Service for a safe and convenient temple journey. Enjoy clean cars, professional drivers, affordable fares, and reliable pickup from Sai Shirdi.",
    image: "/images/keyword/4.jpg",
    link: "/Shirdi-to-Grishneshwar-Cab",
  },
  {
    id: 2,
    name: "Shirdi to Lonavala Cab",
    desc: "Travel from Sai Shirdi to Lonavala comfortably with Rising Cab Service. Our Shirdi to Lonavala Cab service offers clean vehicles, experienced drivers, affordable fares, and convenient pickup for a hassle-free journey.",
    image: "/images/keyword/6.jpg",
    link: "/Shirdi-to-Lonavala-Cab",
  },
  {
    id: 3,
    name: "Shirdi to Mahabaleshwar Cab",
    desc: "Book a Shirdi to Mahabaleshwar Cab with Rising Cab Service for a comfortable and safe trip from Sai Shirdi. Choose from well-maintained cars, professional drivers, affordable pricing, and reliable door-to-door service.",
    image: "/images/keyword/7.jpg",
    link: "/Shirdi-to-Mahabaleshwar-Cab",
  },
  {
    id: 4,
    name: "Shirdi to Saptashrungi Cab",
    desc: "Hire a Shirdi to Saptashrungi Cab with Rising Cab Service for a smooth and comfortable temple trip. We provide reliable pickup from Sai Shirdi, clean vehicles, experienced drivers, and affordable cab fares.",
    image: "/images/keyword/9.jpg",
    link: "/Shirdi-to-Saptashrungi-Cab",
  },
  {
    id: 5,
    name: "Shirdi Darshan Taxi",
    desc: "Book a Shirdi Darshan Taxi with Rising Cab Service for a convenient visit to Sai Baba Temple and nearby attractions. Enjoy comfortable cars, experienced drivers, affordable fares, and reliable local taxi service in Shirdi.",
    image: "/images/keyword/18.jpg",
    link: "/Shirdi-Darshan-Taxi",
  },
  {
    id: 6,
    name: "Shirdi to Ujjain Cab",
    desc: "Travel from Sai Shirdi to Ujjain with Rising Cab Service's reliable Shirdi to Ujjain Cab. Enjoy a comfortable long-distance journey with clean cars, professional drivers, flexible pickup, and affordable one-way or round-trip options.",
    image: "/images/keyword/25.jpg",
    link: "/Shirdi-to-Ujjain-Cab",
  },
  {
    id: 7,
    name: "Shirdi to Saputara Cab",
    desc: "Book a Shirdi to Saputara Cab with Rising Cab Service for a safe and comfortable journey from Sai Shirdi to Saputara. Our clean vehicles, professional drivers, and affordable fares make your trip convenient and stress-free.",
    image: "/images/keyword/26.jpg",
    link: "/Shirdi-to-Saputara-Cab",
  },
  {
    id: 8,
    name: "Shirdi to Pandharpur Cab",
    desc: "Choose Rising Cab Service for a comfortable Shirdi to Pandharpur Cab journey. Travel safely from Sai Shirdi to Pandharpur with experienced drivers, well-maintained vehicles, affordable fares, and convenient pickup and drop service.",
    image: "/images/keyword/29.jpg",
    link: "/Shirdi-to-Pandharpur-Cab",
  },
  {
    id: 9,
    name: "Shirdi to Goa Cab",
    desc: "Book a Shirdi to Goa Cab with Rising Cab Service for a comfortable and reliable long-distance journey from Sai Shirdi. Enjoy spacious cars, professional drivers, affordable fares, and convenient one-way or round-trip cab service.",
    image: "/images/keyword/33.jpg",
    link: "/Shirdi-to-Goa-Cab",
  },
];


const Service = () => {
  return (
    <>

      <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Services
        </h2>
      </div>
    </section>

  


     

      <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
        <div className="container">
          <div className="section-content">
            <div className="twm-cars-section m-b30">
              <div className="row">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.id}
                    className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                    data-wow-delay="0.2s"
                  >
                    <div className="twm-vehicle-fleet-bx twm-custom-grid-3 ">
                      <div className="twm-media twmtitle">
                        <div className="twm-media-pi borderrr twmtitle text-center">
                          <img src={vehicle.image} alt={vehicle.name} />
                        </div>
                      </div>
                      <div className="twm-vehicle-fleet-content ">
                        <h3 className="twm-v-title twmtitle twmtitle text-center">
                          <a className="twmtitle text-center darkcolo" >{vehicle.name}</a>
                        </h3>
                        <ul className="twm-vehicle-facility">
                          <li>{vehicle.desc}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;